/**
 * @file app-ref.ts
 *
 * Holds the global reference to the active <as-app> component.
 * Set by as-app.ts in connectedCallback.
 */

export let AS_APP_EL: any = null;

export function setAsApp(el: any) {
  AS_APP_EL = el;
}
